<div class="join-wait-list o-flex o-flex--column">
  <button mat-raised-button color="primary" *ngIf="featureInWaitList" [disabled]="!!featureInWaitList.id">{{onWaitListButton}}</button>
  <button mat-raised-button color="primary" *ngIf="!featureInWaitList" (click)="joinWaitList()">{{joinWaitListButton}}</button>
  <span class="join-wait-list__extra-info u-font-weight-700 line-height-16 u-font-size-14 u-margin-top-20" *ngIf="featureInWaitList">Joined waitlist {{featureInWaitList.waitlisted_on | date: 'dd/MM/yyyy'}}</span>
</div>
